// import React from "react";
// import medixo from '../../../images/home/medixo.svg'
// import taxongo from '../../../images/home/tax-on-go.svg'
// import tracxn from '../../../images/home/tracxn.svg'
// import microsoft from '../../../images/home/microsoft.svg'
// import aws from '../../../images/home/aws.svg'
// import googleCloud from '../../../images/home/google-cloud.svg'
// import ambitionbox from '../../../images/home/ambitionbox.svg'
// import clutch from '../../../images/home/clutch-logo.svg'
// import googleReviews from '../../../images/home/google-review.svg'
// import glassdoor from '../../../images/home/glassdoor.svg'
// import { Container, Row, Col } from "react-bootstrap";
// import awardLogo from '../../../images/home/top-software-development-company.png'
// import "../home.css"

// const ProductPartners = () => {
//     return (
//         <>
//             <section className="product-partners-wrapper">
//                 <Container fluid>
//                     <Row className="d-flex position-relative">
//                         <Col xs="12" lg="3" className="product-section d-flex flex-column">
//                             <h1 className="text-primary ft-wt-600 text-uppercase mb-4 text-center">Our Products</h1>
//                             <Row className="gap-0 gap-lg-4 justify-content-center">
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-0 my-lg-3">
//                                     <img src={medixo} alt="medixo" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-0 my-lg-3">
//                                     <img src={taxongo} alt="taxongo" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-0 my-lg-3">
//                                     <img src={tracxn} alt="tracxn" loading="lazy" className="img-fluid" />
//                                 </Col>
//                             </Row>
//                         </Col>

//                         <Col xs={12} lg={1} className="d-none d-lg-flex justify-content-center">
//                             <div className="vertical-divider"></div>
//                         </Col>

//                         <Col xs={12} lg={3} className="partner-section mt-4 mt-lg-0 d-flex flex-column">
//                             <h1 className="text-primary ft-wt-600 text-uppercase mb-4 text-center">Our Partners</h1>
//                             <Row className="gap-0 gap-lg-4 justify-content-center">
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <img src={microsoft} alt="microsoft" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <img src={aws} alt="aws" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <img src={googleCloud} alt="google-cloud" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <img src={awardLogo} alt="design-rush" loading="lazy" className="img-fluid" />
//                                 </Col>
//                             </Row>
//                         </Col>
//                         <Col xs={12} lg={1} className="d-none d-lg-flex justify-content-center">
//                             <div className="vertical-divider"></div>
//                         </Col>
//                         <Col xs={12} lg={3} className="partner-section mt-4 mt-lg-0">
//                             <h1 className="text-primary ft-wt-600 text-uppercase mb-4 text-center">Our Ratings</h1>
//                             <Row className="justify-content-center">
//                                 <Col xs="6" lg="12" className="my-1 d-flex align-items-center justify-content-center">
//                                     <a className="cursor-pointer" href="https://clutch.co/profile/acubetech-solutions#highlights" rel="noreferrer" target="_blank" >
//                                         <div>
//                                             <img src={clutch} alt="clutch" loading="lazy" className="img-fluid mb-2" />
//                                             <h6 className="text-primary text-center fw-bold text-decoration-underline">Know More</h6>
//                                         </div>
//                                     </a>
//                                 </Col>
//                                 <Col xs="6" lg="12" className="d-flex align-items-center justify-content-center my-1">
//                                     <a className="cursor-pointer" href="https://www.ambitionbox.com/reviews/acubetech-solutions-reviews" rel="noreferrer" target="_blank" >
//                                         <div>
//                                             <img src={ambitionbox} alt="ambitionbox" loading="lazy" className="img-fluid mb-2" />
//                                             <h6 className="text-primary text-center fw-bold text-decoration-underline">Know More</h6>
//                                         </div>
//                                     </a>
//                                 </Col>
//                                 <Col xs="6" lg="12" className="d-flex align-items-center justify-content-center my-1">
//                                     <a className="cursor-pointer" href="https://www.google.com/search?q=ACubetech+Solutions+Pvt+Ltd" rel="noreferrer" target="_blank" >
//                                         <div>
//                                             <img src={googleReviews} alt="google-review" loading="lazy" className="img-fluid mb-2" />
//                                             <h6 className="text-primary text-center fw-bold text-decoration-underline">Know More</h6>
//                                         </div>
//                                     </a>
//                                 </Col>
//                                 <Col xs="6" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <a className="cursor-pointer" href="https://www.glassdoor.co.in/Reviews/ACubetech-Solutions-Reviews-E1344716.htm" rel="noreferrer" target="_blank" >
//                                         <div>
//                                             <img src={glassdoor} alt="glassdoor" loading="lazy" className="img-fluid mb-2" />
//                                             <h6 className="text-primary text-center fw-bold text-decoration-underline">Know More</h6>
//                                         </div>
//                                     </a>
//                                 </Col>
//                             </Row>
//                         </Col>
//                     </Row>
//                 </Container>
//             </section>
//         </>
//     );
// };

// export default ProductPartners;


// new version

// import React from "react";
// import { Container, Row, Col, Card } from "react-bootstrap";
// import "../home.css";

// // Assets
// import medixo from '../../../images/home/medixo.svg'
// import taxongo from '../../../images/home/tax-on-go.svg'
// import tracxn from '../../../images/home/tracxn.svg'
// import microsoft from '../../../images/home/microsoft.svg'
// import aws from '../../../images/home/aws.svg'
// import googleCloud from '../../../images/home/google-cloud.svg'
// import ambitionbox from '../../../images/home/ambitionbox.svg'
// import clutch from '../../../images/home/clutch-logo.svg'
// import googleReviews from '../../../images/home/google-review.svg'
// import glassdoor from '../../../images/home/glassdoor.svg'
// import awardLogo from '../../../images/home/top-software-development-company.png'

// const ProductPartners = () => {
//     return (
//         <section className="ecosystem-wrapper py-5 bg-light-subtle">
//             <Container fluid="lg">
//                 <Row className="g-4 g-xl-5">

//                     {/* --- OUR PRODUCTS --- */}
//                     <Col xs={12} lg={4}>
//                         <Card className="bento-card h-100 border-0 shadow-sm p-4 p-xl-5 bg-white">
//                             <h3 className="bento-title">Our Products</h3>
//                             <div className="d-flex flex-column justify-content-between h-100 mt-4 gap-4">
//                                 <div className="logo-wrapper">
//                                     <img src={medixo} alt="Medixo" loading="lazy" />
//                                 </div>
//                                 <div className="logo-wrapper">
//                                     <img src={taxongo} alt="TaxOnGo" loading="lazy" />
//                                 </div>
//                                 <div className="logo-wrapper">
//                                     <img src={tracxn} alt="Tracxn" loading="lazy" />
//                                 </div>
//                             </div>
//                         </Card>
//                     </Col>

//                     {/* --- OUR PARTNERS --- */}
//                     <Col xs={12} lg={4}>
//                         <Card className="bento-card h-100 border-0 shadow-sm p-4 p-xl-5 bg-white">
//                             <h3 className="bento-title">Our Partners</h3>
//                             <div className="d-flex flex-column justify-content-between h-100 mt-4 gap-4">
//                                 <div className="logo-wrapper">
//                                     <img src={microsoft} alt="Microsoft Partner" loading="lazy" />
//                                 </div>
//                                 <div className="logo-wrapper">
//                                     <img src={aws} alt="AWS Partner Network" loading="lazy" />
//                                 </div>
//                                 <div className="logo-wrapper">
//                                     <img src={googleCloud} alt="Google Cloud" loading="lazy" />
//                                 </div>
//                                 <div className="logo-wrapper award-wrapper">
//                                     <img src={awardLogo} alt="Top Software Development Company 2025" loading="lazy" />
//                                 </div>
//                             </div>
//                         </Card>
//                     </Col>

//                     {/* --- OUR RATINGS --- */}
//                     <Col xs={12} lg={4}>
//                         <Card className="bento-card h-100 border-0 shadow-sm p-4 p-xl-5 bg-white">
//                             <h3 className="bento-title">Our Ratings</h3>
//                             <div className="mt-4 d-flex flex-column gap-3 h-100 justify-content-center">

//                                 <a href="https://clutch.co/profile/acubetech-solutions#highlights" target="_blank" rel="noreferrer" className="rating-tile">
//                                     <img src={clutch} alt="Clutch Rating" loading="lazy" className="rating-img" />
//                                     <span className="hover-arrow">&rarr;</span>
//                                 </a>

//                                 <a href="https://www.ambitionbox.com/reviews/acubetech-solutions-reviews" target="_blank" rel="noreferrer" className="rating-tile">
//                                     <img src={ambitionbox} alt="AmbitionBox Rating" loading="lazy" className="rating-img" />
//                                     <span className="hover-arrow">&rarr;</span>
//                                 </a>

//                                 <a href="https://www.google.com/search?q=ACubetech+Solutions+Pvt+Ltd" target="_blank" rel="noreferrer" className="rating-tile">
//                                     <img src={googleReviews} alt="Google Reviews" loading="lazy" className="rating-img" />
//                                     <span className="hover-arrow">&rarr;</span>
//                                 </a>

//                                 <a href="https://www.glassdoor.co.in/Reviews/ACubetech-Solutions-Reviews-E1344716.htm" target="_blank" rel="noreferrer" className="rating-tile">
//                                     <img src={glassdoor} alt="Glassdoor Rating" loading="lazy" className="rating-img" />
//                                     <span className="hover-arrow">&rarr;</span>
//                                 </a>

//                             </div>
//                         </Card>
//                     </Col>

//                 </Row>
//             </Container>
//         </section>
//     );
// };

// export default ProductPartners;



import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// Assets
import medixo from "../../../images/home/medixo.svg";
import taxongo from "../../../images/home/tax-on-go.svg";
import tracxn from "../../../images/home/tracxn.svg";
import microsoft from "../../../images/home/microsoft.svg";
import aws from "../../../images/home/aws.svg";
import googleCloud from "../../../images/home/google-cloud.svg";
import ambitionbox from "../../../images/home/ambitionbox.svg";
import clutch from "../../../images/home/clutch-logo.svg";
import googleReviews from "../../../images/home/google-review.svg";
import glassdoor from "../../../images/home/glassdoor.svg";
import awardLogo from "../../../images/home/top-software-development-company.png";

const ProductPartners = () => {
    return (
        <>
            {/* Embedded CSS for High-Impact Bento Ecosystem Section */}
            <style>{`
                .ecosystem-section-wrapper {
                    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
                    padding: 3rem 0;
                    border-top: 1px solid #e2e8f0;
                    border-bottom: 1px solid #e2e8f0;
                    position: relative;
                }

                .ecosystem-badge-pill {
                    background: #f0f9ff;
                    color: #0284c7;
                    border: 1px solid #bae6fd;
                    font-size: 1.25rem;
                    font-weight: 700;
                    letter-spacing: 0.12em;
                    text-transform: uppercase;
                    padding: 0.4rem 1rem;
                    border-radius: 50px;
                    display: inline-block;
                    margin-bottom: 1rem;
                }

                .ecosystem-main-title {
                    font-size: clamp(2rem, 3.5vw, 2.75rem);
                    font-weight: 300;
                    color: #0f172a;
                    line-height: 1.25;
                    letter-spacing: -0.02em;
                }

                /* Bento Card Styling */
                .bento-card-wrapper {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 1.5rem;
                    padding: 1.5rem 2rem;
                    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.03), 0 8px 10px -6px rgba(0, 0, 0, 0.02);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }

                .bento-card-wrapper:hover {
                    transform: translateY(-6px);
                    border-color: #bae6fd;
                    box-shadow: 0 20px 30px -10px rgba(14, 165, 233, 0.15);
                }

                /* Highlighted Titles */
                .bento-header-title {
                    font-size: 1.8rem;
                    font-weight: 800;
                    letter-spacing: -0.01em;
                    color: #0f172a;
                    padding-bottom: 1rem;
                    border-bottom: 2px solid #f1f5f9;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .bento-header-title .title-gradient {
                    color: #0f172a;
                }

                /* Tile Item Frames */
                .ecosystem-tile {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 0.85rem;
                    padding: 1rem 1.25rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    transition: all 0.25s ease;
                    text-decoration: none;
                }

                .ecosystem-tile:hover {
                    background: #ffffff;
                    border-color: #38bdf8;
                    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.1);
                    transform: translateX(4px);
                }

                .ecosystem-logo {
                    max-height: 38px;
                    width: auto;
                    object-fit: contain;
                }

                .award-logo {
                    max-height: 55px;
                    width: auto;
                    object-fit: contain;
                }

                .tile-arrow {
                    color: #0284c7;
                    font-weight: 700;
                    font-size: 1.1rem;
                    opacity: 0.6;
                    transition: transform 0.25s ease, opacity 0.25s ease;
                }

                .ecosystem-tile:hover .tile-arrow {
                    opacity: 1;
                    transform: translateX(3px);
                }
            `}</style>

            <section className="ecosystem-section-wrapper">
                <Container fluid="lg">
                    {/* --- SECTION HEADER --- */}
                    <Row className="justify-content-center text-center mb-5">
                        <Col xs={12} lg={9}>
                            <span className="animate-title badge bg-primary-subtle text-primary rounded-pill px-3 py-2 mb-3 fw-semibold tracking-wider" style={{ fontSize: "1.25rem" }}>
                                OUR ENTERPRISE ECOSYSTEM
                            </span>
                            {/* <span className="ecosystem-badge-pill">
                                Our Enterprise Ecosystem
                            </span> */}
                            <h2 className="ecosystem-main-title">
                                Powering Innovation Through Products, Strategic Partnerships, & Proven Trust
                            </h2>
                        </Col>
                    </Row>

                    {/* --- BENTO GRID --- */}
                    <Row className="g-4 g-xl-5 align-items-stretch">

                        {/* --- COLUMN 1: OUR PRODUCTS --- */}
                        <Col xs={12} lg={4}>
                            <div className="bento-card-wrapper h-100">
                                <div>
                                    <div className="bento-header-title mb-4">
                                        <span className="title-gradient">OUR PRODUCTS</span>
                                        <span className="badge bg-primary-subtle text-primary rounded-pill px-2.5 py-1 ft-12 fw-bold">
                                            IN-HOUSE
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column gap-3">
                                        <div className="ecosystem-tile">
                                            <img src={medixo} alt="Medixo Healthcare Platform" loading="lazy" className="ecosystem-logo" style={{ maxHeight: "91px" }} />
                                        </div>
                                        <div className="ecosystem-tile">
                                            <img src={taxongo} alt="TaxOnGo Financial Suite" loading="lazy" className="ecosystem-logo" />
                                        </div>
                                        <div className="ecosystem-tile">
                                            <img src={tracxn} alt="Tracxn Enterprise Analytics" loading="lazy" className="ecosystem-logo" />
                                        </div>
                                    </div>
                                </div>
                                <p className="text-muted small mb-0 mt-4 pt-3 border-top border-light-subtle">
                                    🚀 Proven SaaS products engineered and scaled by our internal engineering pods.
                                </p>
                            </div>
                        </Col>

                        {/* --- COLUMN 2: OUR PARTNERS --- */}
                        <Col xs={12} lg={4}>
                            <div className="bento-card-wrapper h-100">
                                <div>
                                    <div className="bento-header-title mb-4">
                                        <span className="title-gradient">OUR PARTNERS</span>
                                        <span className="badge bg-info-subtle text-info rounded-pill px-2.5 py-1 ft-12 fw-bold">
                                            GLOBAL
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column gap-3">
                                        <div className="ecosystem-tile">
                                            <img src={microsoft} alt="Microsoft Certified Partner" loading="lazy" className="ecosystem-logo" />
                                        </div>
                                        <div className="ecosystem-tile">
                                            <img src={aws} alt="AWS Partner Network Member" loading="lazy" className="ecosystem-logo" />
                                        </div>
                                        <div className="ecosystem-tile">
                                            <img src={googleCloud} alt="Google Cloud Partner" loading="lazy" className="ecosystem-logo" />
                                        </div>
                                        <div className="ecosystem-tile bg-white border-primary border-opacity-25 justify-content-center py-2">
                                            <img src={awardLogo} alt="Top Software Development Company" loading="lazy" className="award-logo" />
                                        </div>
                                    </div>
                                </div>
                                <p className="text-muted small mb-0 mt-4 pt-3 border-top border-light-subtle">
                                    ☁️ Official cloud & infrastructure certifications backing enterprise-grade delivery.
                                </p>
                            </div>
                        </Col>

                        {/* --- COLUMN 3: OUR RATINGS --- */}
                        <Col xs={12} lg={4}>
                            <div className="bento-card-wrapper h-100">
                                <div>
                                    <div className="bento-header-title mb-4">
                                        <span className="title-gradient">OUR RATINGS</span>
                                        <span className="badge bg-success-subtle text-success rounded-pill px-2.5 py-1 ft-12 fw-bold">
                                            5.0 ★
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column gap-3">
                                        <a href="https://clutch.co/profile/acubetech-solutions#highlights" target="_blank" rel="noreferrer" className="ecosystem-tile">
                                            <img src={clutch} alt="Clutch Reviews" loading="lazy" className="ecosystem-logo" />
                                            <span className="tile-arrow">&rarr;</span>
                                        </a>

                                        <a href="https://www.ambitionbox.com/reviews/acubetech-solutions-reviews" target="_blank" rel="noreferrer" className="ecosystem-tile">
                                            <img src={ambitionbox} alt="AmbitionBox Reviews" loading="lazy" className="ecosystem-logo" />
                                            <span className="tile-arrow">&rarr;</span>
                                        </a>

                                        <a href="https://www.google.com/search?q=ACubetech+Solutions+Pvt+Ltd" target="_blank" rel="noreferrer" className="ecosystem-tile">
                                            <img src={googleReviews} alt="Google Reviews" loading="lazy" className="ecosystem-logo" />
                                            <span className="tile-arrow">&rarr;</span>
                                        </a>

                                        <a href="https://www.glassdoor.co.in/Reviews/ACubetech-Solutions-Reviews-E1344716.htm" target="_blank" rel="noreferrer" className="ecosystem-tile">
                                            <img src={glassdoor} alt="Glassdoor Reviews" loading="lazy" className="ecosystem-logo" />
                                            <span className="tile-arrow">&rarr;</span>
                                        </a>
                                    </div>
                                </div>
                                <p className="text-muted small mb-0 mt-4 pt-3 border-top border-light-subtle">
                                    ⭐ Rated for technical competence, delivery speed, and client satisfaction.
                                </p>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ProductPartners;